import type { IOrderType } from "../../../../api/admin";

/** Sort key for non-deleted org order types in FolderOrderTypesDialog. */
export function compareOrderTypesByNameThenSiteLabel(
  a: Pick<IOrderType, "name" | "site_label">,
  b: Pick<IOrderType, "name" | "site_label">
): number {
  const byName = a.name.localeCompare(b.name);
  if (byName !== 0) return byName;
  return (a.site_label ?? "").localeCompare(b.site_label ?? "");
}
